import { isProd } from "./isProd"

export const clerkPublishableKey = isProd ? 'pk_live_Y2xlcmsuc3BlYWtpbmdvZi5tZSQ' : 'pk_test_dmFzdC11bmljb3JuLTU3LmNsZXJrLmFjY291bnRzLmRldiQ'
export const REACT_APP_PUBLIC_POSTHOG_KEY='phc_G3XK9UuO9U2xC0BCB5SAHSge48AnxQrBJ3MjT2sLfo8'
export const REACT_APP_PUBLIC_POSTHOG_HOST='https://p.speakingof.me'